import * as React from "react";
import {
  StyleSheet,
  FlatList,
  TouchableOpacity,
  ScrollView,
  Text,
  View,
} from "react-native";

import ArticleItem from "./ArticleItem.js";
import { useWindowDimensions } from "react-native";
import { AppDataContext } from "../context/AppDataProvider.js";

const ArticleGridList = (props) => {
  const { colors } = React.useContext(AppDataContext);
  const { width, height } = useWindowDimensions();

  var styles = StyleSheet.create({
    grid: {
      marginBottom: 32,
      marginTop: 0,
      alignItems: "stretch",
      minHeight: 1200,
      backgroundColor: colors.background,
      flex: 1,
      flexGrow: 1,
      zIndex: 0,
      elevation: 0,
    },
  });

  if (!props) {
    return <></>;
  }

  if (!props.items || props.items.length < 1) {
    return (
      <ScrollView>
        <Text>No news articles found, please add some.</Text>
      </ScrollView>
    );
  }

  return (
    <View
      style={
        width > 1000
          ? {
              backgroundColor: colors.background,
              justifyContent: "center",
              marginLeft: "auto",
              marginRight: "auto",
              width: 974,
              height: height,
              flex: 1,
            }
          : {
              backgroundColor: colors.background,
              height: height,
              flex: 1,
            }
      }
    >
      <FlatList
      showsVerticalScrollIndicator={false}
        nestedScrollEnabled
        contentContainerStyle={styles.grid}
        style={{
          backgroundColor: colors.background,
          flex: 1,
          borderLeftWidth: 1,
          borderLeftColor: 'silver',
          borderRightWidth: 1,
          borderRightColor: 'silver',
        }}
        data={props.items}
        onEndReachedThreshold={0.5}
        onEndReached={({ distanceFromEnd }) => {
          if (distanceFromEnd < 0) {
            return;
          }
          props.loadMoreData();
        }}
        keyExtractor={(item, index) => index.toString()}
        renderItem={({ item, index }) => {
          return (
            <TouchableOpacity
              style={{
                flex: 1,
                maxHeight: 600,
                backgroundColor: colors.background,
              }}
              key={index.toString()}
              onPress={() => {
                props.selectFunction(item.id);
              }}
            >
              <ArticleItem item={item} index={index} theme={colors} />
            </TouchableOpacity>
          );
        }}
      />
    </View>
  );
};

export default ArticleGridList;
